module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAACVBMVEUAAABWVlaXl5eottxwAAAAAXRSTlMAQObYZgAAACtJREFUKM9joDIIDQ0NgJDonACYkkHIIQesgoEFqBwywKAIAxwcPHFKDgAAMI0mrRgOqHUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/zxyl/phone_icon.png
// module id = MpDo
// module chunks = 2